
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4679cadb&scoped=true!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GlobalLoader.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GlobalLoader.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4679cadb!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GlobalLoader.vue"),
  /* scopeId */
  "data-v-4679cadb",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/GlobalLoader.vue
// module id = 457
// module chunks = 2